module.exports = __webpack_public_path__ + "media/audio24.2398fa11.wav";